import SecureLS from 'secure-ls';
import { AsyncStorage as AsyncStorageType } from '../types/commonTypes';
import AsyncStorage from '@react-native-async-storage/async-storage';

let storageInstance: AsyncStorageType;

export const isWeb =
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const getChannelId = isWeb ? '101' : '201' 

if (isWeb) {
  // Initialize SecureLS for web
  const secureLS = new SecureLS({ encodingType: 'aes' });

  storageInstance = {
    getItem: async (key: string) => {
      const value = secureLS.get(key);
      return value ? Promise.resolve(value) : Promise.resolve(null);
    },
    setItem: async (key: string, value: string) => {
      secureLS.set(key, value);
      return Promise.resolve();
    },
    removeItem: async (key: string) => {
      secureLS.remove(key);
      return Promise.resolve();
    },
    clear: async () => {
      secureLS.removeAll();
      return Promise.resolve();
    },
  };
} else {
  storageInstance = {
    getItem: async (key: string) => await AsyncStorage.getItem(key),
    setItem: async (key: string, value: string) =>
      await AsyncStorage.setItem(key, value),
    removeItem: async (key: string) => await AsyncStorage.removeItem(key),
    clear: async () => await AsyncStorage.clear(),
  };
}

export default storageInstance;
